/**
 * JM-FAIXAS — o motor das faixas DENTRO DO NAVEGADOR.
 *
 * É o terceiro gêmeo da mesma conta:
 *
 *     campanhas.py    (Python)      ERP, rede de segurança, WhatsApp, Postagens
 *     motor.js        (Function)    o checkout de verdade
 *     jm-faixas.js    (este)        carrinho, barra e tabela da vitrine
 *
 * Os três rodam os MESMOS casos de teste. Se um divergir do outro em um
 * centavo, o teste cruzado quebra e a regra não é publicada.
 *
 * DE ONDE VÊM OS NÚMEROS: de `window.JM_FAIXAS`, que o
 * `snippets/jm-faixas.liquid` escreve lendo o metacampo da loja. Não existe
 * nenhuma tabela escrita neste arquivo — foi exatamente isso que causou a
 * divergência que a Fase 0.5 veio consertar.
 *
 * SE A CONFIGURAÇÃO FALTAR OU VIER TORTA: `disponivel()` devolve false e todo
 * o resto devolve zero. Melhor a vitrine não falar de desconto nenhum do que
 * prometer um desconto que o checkout não vai dar.
 */
(function (global) {
  "use strict";

  var VERSAO_FORMATO = 1;

  /** As naturezas de campanha que este motor sabe calcular. */
  var TIPOS_SUPORTADOS = ["volume_quantidade"];

  /**
   * A configuração está presente e num formato que sabemos ler?
   *
   * `tipo` entrou aqui porque a ausência dele era um FAIL-OPEN: uma campanha que
   * mudasse de natureza — de volume por quantidade para outra coisa — continuava
   * sendo calculada por este motor, que só sabe uma delas. Documento cuja
   * natureza não reconhecemos não é documento pela metade: é documento que não é
   * nosso.
   *
   * Documento sem `tipo` é aceito: o campo é recente, e recusá-lo derrubaria a
   * regra que está publicada hoje sem que nada tenha mudado nela.
   */
  function disponivel(cfg) {
    var c = cfg || global.JM_FAIXAS;
    if (!c || (c.v | 0) !== VERSAO_FORMATO) return false;
    if (!Array.isArray(c.faixas) || !c.faixas.length) return false;
    if (c.tipo && TIPOS_SUPORTADOS.indexOf(c.tipo) < 0) return false;
    return true;
  }

  /**
   * A campanha está em vigor AGORA?
   *
   * Sem datas, é permanente — mas isso vale só porque o publicador garante que
   * regra sem data é regra sem término. Data presente e ilegível NÃO é tratada
   * como ausente: é "não sei", e não sei cala.
   *
   * `agoraMs` existe para o teste conseguir viajar no tempo sem mexer no relógio
   * da máquina.
   */
  function vigente(cfg, agoraMs) {
    var c = cfg || global.JM_FAIXAS;
    if (!c) return false;
    var agora = (agoraMs === undefined || agoraMs === null) ? Date.now() : agoraMs;

    var ini = c.campanha_inicio;
    if (ini !== undefined && ini !== null && ini !== "") {
      var tIni = Date.parse(ini);
      if (isNaN(tIni)) return false;             // ilegível: não sei
      if (agora < tIni) return false;            // ainda não começou
    }

    var fim = c.campanha_fim;
    if (fim !== undefined && fim !== null && fim !== "") {
      var tFim = Date.parse(fim);
      if (isNaN(tFim)) return false;             // ilegível: não sei
      if (agora > tFim) return false;            // já terminou
    }
    return true;
  }

  /**
   * Esta campanha é para ESTE cliente?
   *
   * `cliente` é `{ id, tags }`, ou nada quando o visitante é anônimo.
   *
   * Campanha aberta (`modo: "todos"`, ou sem `clientes`) vale para todo mundo.
   * Campanha restrita só vale para quem se consegue PROVAR que está na lista —
   * e visitante anônimo não prova nada. Vitrine é pública: não se anuncia a
   * quem não pertence um preço reservado a quem pertence.
   */
  function clientePermitido(cfg, cliente) {
    var c = cfg || global.JM_FAIXAS;
    if (!c) return false;
    var regra = c.clientes || {};
    var modo = regra.modo || "todos";
    if (modo === "todos") return true;

    if (!cliente) return false;                  // anônimo diante de restrição

    if (casa(cliente.id, regra.ids)) return true;
    if (emAlguma(cliente.tags, regra.tags)) return true;
    return false;                                // não provou: fica de fora
  }

  function config(cfg) {
    return disponivel(cfg) ? (cfg || global.JM_FAIXAS) : null;
  }

  /** O mínimo de peças do carrinho. Sem configuração, cai no padrão seguro. */
  function minimoPecas(cfg, padrao) {
    var c = config(cfg);
    var n = c ? (c.minimo_pecas | 0) : 0;
    return n > 0 ? n : (padrao === undefined ? 10 : padrao);
  }

  /**
   * Quanto é `valorBp` de `precoCentavos`, arredondado meio para cima.
   * ESTA LINHA PRECISA SER IDÊNTICA à `_percentual_de` do campanhas.py e à
   * `percentualDe` do motor.js. Tudo inteiro: `Math.round` arredondaria
   * diferente do Python.
   */
  function percentualDe(precoCentavos, valorBp) {
    return Math.floor((precoCentavos * valorBp + 5000) / 10000);
  }

  /**
   * A MAIOR faixa que essa quantidade alcança. Nenhuma outra é somada.
   * 100 peças ganham R$ 5,00 por peça — não R$ 1 + R$ 3 + R$ 4 + R$ 5.
   */
  function faixaAtingida(faixas, quantidade) {
    if (!Array.isArray(faixas)) return null;
    var escolhida = null;
    for (var i = 0; i < faixas.length; i++) {
      var f = faixas[i];
      if (!f || typeof f !== "object") continue;
      var minimo = f.min | 0;
      if (quantidade < minimo) continue;
      if (f.max !== null && f.max !== undefined && quantidade > f.max) continue;
      if (escolhida === null || minimo > (escolhida.min | 0)) escolhida = f;
    }
    return escolhida;
  }

  /** Quanto sai de UMA peça, nunca mais do que ela custa. */
  function descontoDaPeca(faixa, precoCentavos) {
    if (!faixa) return 0;
    var bruto = faixa.tipoValor === "percentual"
      ? percentualDe(precoCentavos, faixa.bp | 0)
      : (faixa.centavos | 0);
    if (bruto < 0) return 0;
    return Math.min(bruto, precoCentavos);
  }

  /** 'gid://shopify/Product/999' e '999' viram os dois '999'. */
  function soId(valor) {
    var texto = String(valor === null || valor === undefined ? "" : valor);
    var barra = texto.lastIndexOf("/");
    return (barra >= 0 ? texto.slice(barra + 1) : texto).trim();
  }

  function casa(valor, lista) {
    if (!lista || !lista.length) return false;
    var alvo = soId(valor);
    if (!alvo) return false;
    for (var i = 0; i < lista.length; i++) {
      if (soId(lista[i]) === alvo) return true;
    }
    return false;
  }

  /**
   * Essa linha do carrinho entra na regra?
   *
   * Mesma ordem do Python e da Function: exclusão absoluta (vale-presente),
   * depois quem PODE participar, depois as exclusões.
   * EXCLUSÃO SEMPRE GANHA DE INCLUSÃO.
   *
   * `linha.colecoes` é a lista de coleções da peça (números ou gids). É por
   * ela que a PROMOÇÃO fica de fora — e agora pelas DUAS coleções PROMOÇÃO,
   * não só pela primeira.
   */
  function elegivel(cfg, linha) {
    var c = config(cfg);
    if (!c) return false;
    var ex = c.excluidos || {};
    var inc = c.elegiveis || {};

    if (linha.valePresente && ex.vale_presente !== false) return false;

    if ((inc.modo || "todos") !== "todos") {
      var entrou = casa(linha.produtoId, inc.produtos) ||
                   casa(linha.varianteId, inc.variantes) ||
                   emAlguma(linha.colecoes, c.colecoesIncluidas) ||
                   emAlguma(linha.tags, c.tagsIncluidas) ||
                   casa(linha.tipoProduto, inc.tipos) ||
                   casa(linha.fornecedor, inc.fornecedores);
      if (!entrou) return false;
    }

    if (emAlguma(linha.colecoes, c.colecoesExcluidas)) return false;
    if (casa(linha.produtoId, ex.produtos)) return false;
    if (casa(linha.varianteId, ex.variantes)) return false;
    if (emAlguma(linha.tags, c.tagsExcluidas)) return false;
    if (casa(linha.tipoProduto, ex.tipos)) return false;
    if (casa(linha.fornecedor, ex.fornecedores)) return false;
    if (linha.emPromocao && ex.em_promocao) return false;

    return true;
  }

  function emAlguma(daPeca, daRegra) {
    if (!daRegra || !daRegra.length || !daPeca || !daPeca.length) return false;
    for (var i = 0; i < daPeca.length; i++) {
      for (var j = 0; j < daRegra.length; j++) {
        if (soId(daPeca[i]) === soId(daRegra[j])) return true;
        if (String(daPeca[i]).toLowerCase() === String(daRegra[j]).toLowerCase()) return true;
      }
    }
    return false;
  }

  /**
   * A conta inteira. Mesma saída que `campanhas.calcular` e que o `calcular`
   * do motor.js.
   *
   * linhas = [{ id, quantidade, precoCentavos, produtoId, varianteId,
   *             colecoes: [], tags: [], valePresente, emPromocao }]
   */
  function calcular(linhas, cfg, contexto) {
    var vazio = { aplicou: false, qtdElegivel: 0, faixa: null,
                  descontoCentavos: 0, linhas: [] };
    var c = config(cfg);
    if (!c) return vazio;

    /* Dois portões que valem para o CARRINHO INTEIRO, e não linha a linha:
       uma campanha fora de vigência, ou que não é deste cliente, simplesmente
       não se aplica — e aí não há peça elegível nenhuma.
       `contexto` é opcional: sem ele o visitante é tratado como anônimo, que é
       a leitura segura. */
    var ctx = contexto || {};
    if (!vigente(c, ctx.agoraMs)) return vazio;
    if (!clientePermitido(c, ctx.cliente)) return vazio;

    var elegiveis = [], qtd = 0;
    for (var i = 0; i < (linhas || []).length; i++) {
      var l = linhas[i];
      if (!elegivel(c, l)) continue;
      elegiveis.push(l);
      qtd += l.quantidade | 0;
    }
    if (!elegiveis.length) return vazio;

    var faixa = faixaAtingida(c.faixas, qtd);
    if (!faixa) return { aplicou: false, qtdElegivel: qtd, faixa: null,
                         descontoCentavos: 0, linhas: [] };

    var total = 0, saida = [];
    for (var k = 0; k < elegiveis.length; k++) {
      var linha = elegiveis[k];
      var preco = linha.precoCentavos | 0;
      var q = linha.quantidade | 0;
      var porPeca = descontoDaPeca(faixa, preco);
      if (porPeca <= 0) continue;
      total += porPeca * q;
      saida.push({ id: linha.id, quantidade: q, precoCentavos: preco,
                   descontoUnitarioCentavos: porPeca });
    }
    return { aplicou: total > 0, qtdElegivel: qtd, faixa: faixa,
             descontoCentavos: total, linhas: saida };
  }

  /**
   * O degrau seguinte, para a mensagem de "faltam N peças".
   * Devolve null quando já se está no melhor preço.
   */
  function proximaFaixa(quantidade, cfg) {
    var c = config(cfg);
    if (!c) return null;
    var ordenadas = c.faixas.slice().sort(function (a, b) {
      return (a.min | 0) - (b.min | 0);
    });
    for (var i = 0; i < ordenadas.length; i++) {
      if (quantidade < (ordenadas[i].min | 0)) {
        return { faixa: ordenadas[i], faltam: (ordenadas[i].min | 0) - quantidade };
      }
    }
    return null;
  }

  /** '5.00' a partir de 500 — feito com inteiros, sem ponto flutuante. */
  function centavosParaTexto(cent) {
    var n = Math.max(0, cent | 0);
    var inteiros = Math.floor(n / 100);
    var resto = n % 100;
    return inteiros + "." + (resto < 10 ? "0" : "") + resto;
  }

  /** 'R$ 44,99' a partir de 4499. */
  function dinheiro(cent) {
    return "R$ " + centavosParaTexto(cent).replace(".", ",");
  }

  var api = {
    VERSAO_FORMATO: VERSAO_FORMATO,
    disponivel: disponivel,
    config: config,
    minimoPecas: minimoPecas,
    percentualDe: percentualDe,
    faixaAtingida: faixaAtingida,
    descontoDaPeca: descontoDaPeca,
    elegivel: elegivel,
    vigente: vigente,
    clientePermitido: clientePermitido,
    TIPOS_SUPORTADOS: TIPOS_SUPORTADOS,
    calcular: calcular,
    proximaFaixa: proximaFaixa,
    centavosParaTexto: centavosParaTexto,
    dinheiro: dinheiro,
  };

  global.JMFaixas = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;
})(typeof window !== "undefined" ? window : globalThis);
